import styled from 'styled-components';
import { Button } from '@components/Button';
import { Columns } from '@components/Columns';
import { CloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery } from '@utils/styledTheme.util';

export const StyledButton = styled(Button)`
  background: transparent;
`;

export const StyledConnectedGuestList = styled(CloudImage)`
  width: 100%;
  ${themeMediaQuery('lg')} {
    width: 1025px;
    display: block;
    margin: 0 auto;
  }
`;

export const TextPairingWrapper = styled(TextPairing)`
  .text-pairing-title {
    max-width: 700px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      max-width: 370px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 800px;
    }
  }
`;

export const ColumnWrapper = styled(Columns.Column)`
  display: flex;
  flex-direction: column;
  ${themeMediaQuery('below_sm')} {
    flex-direction: column-reverse;
  }
`;
